import { render, staticRenderFns } from "./SelectBreed.vue?vue&type=template&id=2da6cfde"
import script from "./SelectBreed.vue?vue&type=script&lang=js"
export * from "./SelectBreed.vue?vue&type=script&lang=js"
import style0 from "./SelectBreed.vue?vue&type=style&index=0&id=2da6cfde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports